import {
   styled
  ,Card
} from 'external/material'
import {centerVertically, countBox} from 'utils/style'
import { courseItemWidth, courseItemHeight } from 'settings'

const Course = styled(Card)(() => {
  return {
    "&.MuiCard-root" : {
      display: 'flex',
      borderRadius: 50,
      height: courseItemHeight,
      width: courseItemWidth,
      padding: '25px 30px',
      boxShadow: '1px 0px 140px 10px rgba(227,228,230,0.85)'
    },
    "& .MuiCardMedia-root": {
      border: 'solid 1px #dfdfdf',
      borderRadius: 15,
      width:201,
      height:260
    },
    "& .MuiCardContent-root": {
      marginLeft: 15,
      flexGrow: 1,
      flexShrink: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 2 
    },
    "& .courseName": {
      color: '#434b5f',
    },
    "& .teacher": {
      marginTop: 20,
      display: 'flex',
      "& .teacherName": {
        ...centerVertically,
        marginLeft: 10,
        fontSize: '13pt',
        color: '#606674',
        flexShrink: 0,
        flexGrow: 1
      }
    },
    "& .courseName": {
      ...centerVertically,
      width: 240,
      fontSize: '16pt',
      fontWeight: 500,
      color: '#434b5f',
      flexGrow: 1,
      flexShrink: 0
    },
    "& .group": {
      marginTop: 20,
      width: 240,
      display: 'flex',
      "& .groupIcon": {
        ...centerVertically,
        color: '#809ab3',
        fontSize: '28px'
      },
      "& .groupName": {
        ...centerVertically,
        marginLeft: 10,
        fontSize: '13pt',
        color: '#606674',
        flexGrow: 1,
        flexShrink: 0
      }
    },
    "& .assignments": {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: "flex-end",
      "& .wrapper": {
        display: 'flex',
        justifyContent: 'flex-end',
        "& .assignment": {
          marginLeft: 20,
          "&:first-of-type": {
            marginLeft: 5 
          }
        },
        "& .icon": {
          display: 'flex',
          justifyContent: 'center',
        },
        ...countBox({marginTop: 5})
      }
    }
  }
})

export {Course as default}
